export enum FieldTypes {
  Dropdown = 'Dropdown',
  Textbox = 'Textbox',
  RadioButton = 'RadioButton',
  CheckboxList = 'CheckboxList',
  FileUpload = 'FileUpload',
  Textarea = 'Textarea',
  Checkbox = 'Checkbox'
}
